
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import util from './common/util';
import MenuComponent from './views/navmenu/navmenu.vue';
import HeaderComponent from './views/header/header.vue';
import ReportComponent from './views/checkreport/checkreport.vue';

@Component({
    components: {
        MenuComponent,
        HeaderComponent,
        ReportComponent
    }
})
export default class AppComponent extends Vue {

    //同步路由信息
    getCurrentRoute() {
        //获取当前路由
        let path = this.$route.path;
        path = path == '/' ? 'studytasks' : path.substr(1);
        //更新路由状态信息
        this.$store.commit({
            type: 'changeMenuIndex',
            currentMenuIndex: path,
        });
    }

    //拦截器
    interceptor() {
        //请求拦截器
        this.axios.interceptors.request.use(
            config => {
                // 2022-1-11，难以理解的代码，注释
                //this.getCurrentRoute();
                if (config.method == 'get') {
                    config.params = {
                        _t: new Date().getTime(),
                        ...config.params
                    }
                }
                return config;
            }
        );

        //响应拦截器
        this.axios.interceptors.response.use(
            response => {
                return response;
            },
            error => {
                if (error.response) {
                    switch (error.response.status) {
                        case 401:
                            window.location.href = error.response.headers.location;
                            localStorage.removeItem('access-user');
                            break;
                    }
                }
            }
        );
    }

    //跳转链接
    toUrl(path, query) {
        this.$router.push({
            path: path,
            query: query
        })
    }

    //获取当前用户信息
    getCurrentUser() {
        this.axios.get('/api/personalcenter/getCurrentUser').then((data) => {
            let dataSet = data.data;
            localStorage.setItem('access-user', JSON.stringify(dataSet));
            this.$store.commit({
                type: 'changeAccountType',
                accountType: dataSet.accountType,
            });
        });
    }

    created() {
        //启用拦截器
        this.interceptor();
        this.getCurrentRoute();
        this.getCurrentUser();
    }
    footer: string = '';
    mounted() {
    }
}

